import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { TokenService } from './services/token.service'

export const authGuard: CanActivateFn = () => {
  const router = inject(Router)
  const token = localStorage.getItem('token')
  if (!token) {
    router.navigate(['/login'])
    return false
  }
  return true
}

export const preventLoginForAuthenticatedUserGuard: CanActivateFn = () => {
  const router = inject(Router)
  const tokenService = inject(TokenService)
  if (localStorage.getItem('token') && !tokenService.isTokenExpired()) {
    router.navigate(['/home'])
    return false
  }
  return true
}
